var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"turn-button",staticStyle:{"font-size":"1.5rem"}},[_c('b-icon',{attrs:{"icon":"toggle-off","variant":"danger"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }